<template>
    <modal :id="modal" :name="modal" :width="'100%'" :height="'auto'" :scrollable="true" :adaptive="true" :close-on-backdrop="false" :close-on-esc="false" :click-to-close="false"
    styles="background-color: #AB1F08 !important; 
                margin-bottom: 60px !important;
                overflow-y: scroll; 
                max-width: 1000px; 
                margin: 0 auto;">
        <div class="button-close-position">
            <button class="button-close"
                @click="hideModal()">
                X
            </button>
        </div>
     
        <div class="responsive-iframe">
            <video width="100%" controls autoplay>
                <source :src="'images/mpower-new/'+video" type="video/mp4">
            </video>
        </div>
    
        <div class="margin-bottom-90 padding-left-15 padding-right-15 padding-top-20 mobile-display" :style="loadMobileBg">
            <div class="content bottom-0">
                <div class="one-half ovr-small-half">
                    <div class="border-10">
                        <div class="caption-image">
                            <img v-bind:src="'images/mpower-new/'+badge" class="responsive-image img-height-90">
                        </div>
                    </div>
                </div>
                <div class="one-half large-half last-column text-left">
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title}}</p>
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title1}}</p>
                    <p class="font-12 convention margin-bottom-0">{{description1}}</p>
                    <p v-if="modal=='thailand-modal'" class="font-10 color-white line-normal margin-top-5">Eligibility: Y1 Agents & Introducers</p>
                    <p class="font-10 color-white line-normal  margin-top-5">{{description2}}</p>
                </div>
                <div class="clear"></div>
            </div>
            <br>
            <div v-if="modal=='thailand-modal'">
                <div class="content banner-card text-left">
                    <span class="font-12 line-normal color-grey bold">Eligibility :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>Y1 New Agent</li>
                            <li>Qualifying Period: 1 + 3 Months</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">Requirement : </span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>4 cases + RM18,000 PVI Attend GPS/GENStar</li>
                        </ul>
                    </p>
                </div>
                <div class="content banner-card text-left">
                    <div class="new-close-position">
                        <img v-bind:src="'images/mpower-new/explore_the_world/new-badge.png'" >
                    </div>
                    <span class="font-12 line-normal color-grey bold"> Eligibility :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>Introducer</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">Requirement : </span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>2 Rising Star Qualifiers</li>
                        </ul>
                    </p>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:15px;">
                    <span class="font-12 line-normal color-grey bold">Reward :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>3D2N Bangkok</li>
                        </ul>
                    </p>
                </div>
            </div>
            <div v-else>
                <div class="content banner-card text-left">
                    <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS RM{{ y1y2agentspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR or 90% CYPR (whichever is higher)</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">AGENTS RM{{ agentspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">LEADER PS RM{{ leaderpspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:15px;">
                    <span class="font-12 line-normal color-grey bold">DIRECT UNIT RM{{ directunitpvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">GROUP RM{{ grouppvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>80% 1YPR</li>
                        </ul>
                    </p>
                </div>
            </div>
            <p class="tnc-text">
                For <b>INTERNAL CONSUMPTION</b> only. Please refer to memorandum GMLAM 2024-002, for more details.
            </p>
        </div>
        <div class="margin-bottom-90  padding-left-15 padding-right-15 padding-top-20 ipad-display" :style="loadTabletBg">
            <div class="content bottom-0">
                <div class="one-half ovr-small-half">
                    <div class="border-10">
                        <div class="caption-image">
                            <img v-bind:src="'images/mpower-new/'+badge" class="responsive-image img-height-90">
                        </div>
                    </div>
                </div>
                <div class="one-half large-half last-column text-left">
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title}}</p>
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title1}}</p>
                    <p class="font-12 convention margin-bottom-0">{{description1}}</p>
                    <p v-if="modal=='thailand-modal'" class="font-10 color-white line-normal margin-top-5">Eligibility: Y1 Agents & Introducers</p>
                    <p class="font-10 color-white line-normal  margin-top-5">{{description2}}</p>
                </div>
                <div class="clear"></div>
            </div>
            <br>
            <div v-if="modal=='thailand-modal'">
                <div class="content banner-card text-left">
                    <span class="font-12 line-normal color-grey bold">Eligibility :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>Y1 New Agent</li>
                            <li>Qualifying Period: 1 + 3 Months</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">Requirement : </span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>4 cases + RM18,000 PVI Attend GPS/GENStar</li>
                        </ul>
                    </p>
                  
                </div>
                <div class="content banner-card text-left">
                    <div class="new-close-position">
                        <img v-bind:src="'images/mpower-new/explore_the_world/new-badge.png'" >
                    </div>
                    <span class="font-12 line-normal color-grey bold"> Eligibility :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>Introducer</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">Requirement : </span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>2 Rising Star Qualifiers</li>
                        </ul>
                    </p>
                    
                </div>
                <div class="content banner-card text-left" style="margin-bottom:15px;">
                    <span class="font-12 line-normal color-grey bold">Reward :</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>3D2N Bangkok</li>
                        </ul>
                    </p>
                </div>
            </div>
            <div v-else>
                <div class="content banner-card text-left">
                    <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS RM{{ y1y2agentspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR or 90% CYPR (whichever is higher)</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">AGENTS RM{{ agentspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">LEADER PS RM{{ leaderpspvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>12 cases</li>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:15px;">
                    <span class="font-12 line-normal color-grey bold">DIRECT UNIT RM{{ directunitpvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>85% 1YPR</li>
                        </ul>
                    </p>
                    <br>
                    <span class="font-12 line-normal color-grey bold">GROUP RM{{ grouppvi }} PVI</span>
                    <p class="font-12 line-normal paragraph color-grey">
                        <ul>
                            <li>80% 1YPR</li>
                        </ul>
                    </p>
                </div>
            </div>
          
            <p class="tnc-text">
                For <b>INTERNAL CONSUMPTION</b> only. Please refer to memorandum GMLAM 2024-002, for more details.
            </p>
        </div>
    </modal>
</template>
<style>
    .new-close-position{
        position: absolute;
        z-index: 1;
        top: -10px;
        left: -10px;
    }

    .bold{
        font-family: 'HelveticaNeueLTStd-Bd';
    }

    .bangkok-header{
        height: 300px;
        width: auto;
        padding-top: 20px;
    }

    .tnc-text{
        font-size: 11px;
        color: #DADAD9;
        text-align: left;
        padding-left: 20px;
    }

    .convention{
        color: #C6C6C6;
    }

    .banner-card{
        /* background-color: #dadad9 !important; */
        color: #7B7B7A;
    }
    
    .explore-banner{
        background-color: #AB1F08 !important; margin-bottom: 60px !important;
        overflow-y: scroll; max-width: 1000px; margin: 0 auto;

    }
    body.modal-open {
        overflow: hidden;
    }
   
    .button-close-position{
        position: absolute;
        z-index: 1;
        top: 5px;
        right: 5px;
    }
    .button-close {
        background-color: grey;
        height: 30px;
        width: 30px;
        border-radius: 16px;
        cursor: pointer;
        font-weight: bold;
        margin-right: 10px;
        margin-top: 10px;
    }
    .border-10{
        border-radius: 10px !important;
    }
    .modal-custom {
        background-color: #191919 !important;
    }
    .margin-20 {
        margin-bottom: 20px !important;
    }
    ul {
        margin-left: 15px;
        margin-bottom: 0 !important;
    }
    ul > li {
        margin-bottom: 0 !important;
        line-height: normal !important;
        color : #7B7B7A;
    }
    p {
        margin-bottom: 0 !important;
    }
    p.margin-btm {
        margin-bottom: 20px !important;
    }
    .line-normal {
        line-height: normal;
    }
    .font-18 {
        font-size: 18px;
    }
    .font-15 {
        font-size: 15px;
    }
    .paragraph {
        color : #C6C6C6;
    }
    .first-column{
        width: 40% !important;
    }
    .img-height-90 {
        height: 90px !important;
    }
    .ovr-small-half {
        margin-right: 5% !important;
        width: auto !important;
    }
    @media (max-width: 325px){
        .content {
            margin: 0px 15px 20px 15px!important;
        }
    }
    @media (min-width: 768px){
        .ovr-small-half {
            margin-right: 2% !important;
        }
    }
</style>
<script>
export default {
    name: 'ExploreBannerContent',
    props: {
        modal: String,
        icon: String,
        title: String,
        title1: String,
        description1: String,
        description2: String,
        color: String,
        image: String,
        positionSlide2: String,
        link: String,
      
        y1y2agentspvi: String,
        agentspvi: String,
        leaderpspvi: String,
        directunitpvi: String,
        grouppvi: String,

        badge: String,
        video:String
    },
    components: {},
    computed: {
        loadMobileBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/mobile.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
            }
        },
        loadTabletBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/iPad.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat'
            }
        },
    },
    methods: {
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
    }
}
</script>
